let $ = jQuery;

let sfspcaUserContent = window.sfspcaUserContent;


let form = $('.js-submitUserContent');

let progress = $('.progressBar', form)
let bar = $('.bar', form);
let percent = $('.percent', form);

let submitBtn = $('button[type="submit"]', form);

$('.js-toggleUserStorySubmit').on('click', () => {
  $('body').toggleClass('user-form-is-visible');

  if ($('body').hasClass('user-form-is-visible')) {
    $('.js-userContentSubmitPopup').css({
      top: $(window).scrollTop() + 30
    });
  }

  return false;
});

$('.js-closeUserStorySubmit').on('click', () => {
  $('body').removeClass('user-form-is-success')
  return false;
});

let successPopup = $('.userContentSubmit__success');


function clearFormProgress() {
  let percentVal = '0%';

  bar.width(percentVal)
  percent.html(percentVal);

  progress.hide();
}


let beforeSend = (xhr) => {
  xhr.setRequestHeader('X-WP-Nonce', sfspcaUserContent.nonce);

  progress.show();

  form.addClass('is-submitting');
  submitBtn.attr('disabled', true);
};

let onUploadProgress = (event, position, total, percentComplete) => {
  let percentVal = percentComplete + '%';

  bar.width(percentVal)
  percent.html(percentVal);
};

let onSuccess = () => {
  let percentVal = '100%';

  bar.width(percentVal)
  percent.html(percentVal);

  $('.js-toggleUserStorySubmit').first().click();
  $('body').addClass('user-form-is-success');

  $('body, html').animate({
    scrollTop: successPopup.offset().top
  });

  form.parsley().reset();
  form.clearForm().resetForm();
};

let onComplete = () => {
  clearFormProgress();
  form.removeClass('is-submitting');
  submitBtn.removeAttr('disabled');
};


let fileUploader = $('.js-userContentFileUpload');
let fileList = $('.js-userContentFiles', fileUploader)

$('input[type="file"]', fileUploader)[0].onchange = function () {
  fileList.empty();
  if (this.files.length) {
    $.each(this.files, (i, file) => {
      fileList.append(`<span>${file.name}</span>`);
    });
  }
};

$('.js-submitUserContent').parsley().on('form:submit', () => {
  $(form).ajaxSubmit({
    url: sfspcaUserContent.restURL,
    beforeSend: beforeSend,
    uploadProgress: onUploadProgress,
    success: onSuccess,
    complete: onComplete
  });
  return false;
});


// WEBPACK FOOTER //
// ./assets/src/javascripts/userContent/form/submit.js